// TODO fill in the rest of these options
export enum ConditionExceptionStatus {
    APPROVED_BY_INVESTOR = 'APPROVED_BY_INVESTOR'
}

export const conditionExceptionStatusDisplay = {
    [ConditionExceptionStatus.APPROVED_BY_INVESTOR]: 'Approved by investor'
};
